/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import AppText from "../other/AppText";
import LocationCard from "./LocationCard";
import LoadingDots from "../other/LoadingDots";

const NearestLocations = ({
  selectedPlace,
  moreDetails,
  setNearestMarkers,
}: {
  selectedPlace: any;
  moreDetails: string;
  setNearestMarkers: (branches: any) => void;
}) => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentPath = usePathname();
  const fetchNearest = async (lat: any, lng: any) => {
    setLoading(true);

    try {
      const response = await fetch("/api/fetch-nearest", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ lat, lng, lang: currentPath.split("/")[1] }),
      });
      const res = await response.json();

      const getLocationData = (res.items || []).map((item: any) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return item.fields;
      });

      const tmp = (res.items || []).reduce((accu: any, item: any) => {
        const id = item.sys.id;
        return {
          ...accu,
          [id]: true,
        };
      }, {});

      setNearestMarkers(tmp);

      setBranches(getLocationData);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const lat =
      typeof selectedPlace?.geometry?.location?.lat === "string"
        ? selectedPlace?.geometry?.location?.lat
        : selectedPlace?.geometry?.location?.lat();
    const lng =
      typeof selectedPlace?.geometry?.location?.lng === "string"
        ? selectedPlace?.geometry?.location?.lng
        : selectedPlace?.geometry?.location?.lng();
    if (!lat || !lng) return;
    fetchNearest(lat, lng);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlace]);

  if (!branches.length) return null;
  return (
    <>
      <div className="mt-10 mb-5">
        <AppText type={"HEADLINE_MEDIUM"}>Nearest Locations</AppText>
      </div>
      {loading && <LoadingDots />}
      {!loading && (
        <div className="lg:justify-between flex flex-wrap gap-4 p-4 bg-white">
          {branches.map((branch, index) => {
            return <LocationCard key={index} item={branch} moreDetails={moreDetails} />;
          })}
        </div>
      )}
    </>
  );
};

export default NearestLocations;
